export default __webpack_public_path__ + "static/media/partner_img_10.37b78c41.svg";